import React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export function LaborModelStepBadge({ stepNumber }) {
  return (
    <span
      aria-hidden="true"
      className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-violet-600 text-xs font-semibold text-white"
    >
      {stepNumber}
    </span>
  );
}

function LaborModelSection({
  stepNumber,
  title,
  description,
  summary,
  defaultExpanded = false,
  collapseRequest,
  grouped = false,
  isLastGroupedItem = false,
  allowOverflow = false,
  children,
}) {
  const [expanded, setExpanded] = React.useState(
    defaultExpanded && !collapseRequest
  );
  const contentId = React.useId();

  React.useEffect(() => {
    if (collapseRequest) setExpanded(false);
  }, [collapseRequest]);

  return (
    <section
      className={`overflow-hidden bg-white ${
        grouped
          ? `${isLastGroupedItem ? "" : "border-b border-slate-200"}`
          : "rounded-xl border border-slate-200 shadow-sm"
      }`}
    >
      <button
        type="button"
        className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left transition-colors hover:bg-slate-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-violet-600"
        aria-expanded={expanded}
        aria-controls={contentId}
        onClick={() => setExpanded((current) => !current)}
      >
        <div className="flex min-w-0 items-start gap-3">
          <LaborModelStepBadge stepNumber={stepNumber} />
          <div className="min-w-0">
            <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
              <h2 className="text-lg font-semibold text-slate-900">
                <span className="sr-only">Step {stepNumber}: </span>
                {title}
              </h2>
              {summary ? (
                <span className="text-sm text-slate-500">{summary}</span>
              ) : null}
            </div>
            <p className="mt-1 max-w-4xl text-sm text-slate-500">
              {description}
            </p>
          </div>
        </div>
        <ExpandMoreIcon
          className={`shrink-0 text-slate-500 transition-transform ${
            expanded ? "rotate-180" : ""
          }`}
        />
      </button>
      {expanded ? (
        <div
          id={contentId}
          className={`border-t border-slate-200 ${
            allowOverflow ? "overflow-visible" : "overflow-hidden"
          }`}
        >
          {children}
        </div>
      ) : null}
    </section>
  );
}

export default LaborModelSection;
